import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/me`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function update(profile) {
  const payload = jsona.serialize({
    stuff: profile
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/me/update/${profile.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function updatePassword(profile) {
  const payload = jsona.serialize({
    stuff: profile
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/me/updatePassword/${profile.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function updateAgency(profile) {
  const payload = jsona.serialize({
    stuff: profile
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/me/updateAgency/${profile.id}`, payload, options)
    .then(response => {
      return response.data.data;
    });
}

function updateAgencyToNull(profile) {
  const payload = null;

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/me/updateAgencyToNull/${profile.id}`, payload, options)
    .then(response => {
      return response.data.data;
    });
}

export default {
  get,
  update,
  updatePassword,
  updateAgency,
  updateAgencyToNull
};
